import { NSAPhoneVerificationPage, NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountRoutes } from "../AccountRoutes";

interface VerifyPhonePageProps extends NSARouterMakerResult, AccountRouterProps
{
	callback?: string;
}

function VerifyPhonePage(props: VerifyPhonePageProps) 
{

	return (
		<>
			<AccountLayout {...props} title={{ title: 'Verification Code' }}
				notifier={props.notifier}
			>
				<NSAPhoneVerificationPage
					{...props}
					callback={props.callback ?? AccountRoutes.UserProfile}
				/>
			</AccountLayout>
		</>
	);
};
export default VerifyPhonePage;